import Promise from 'bluebird';

import {
  SET_LOADING,
  SET_PERCENT
} from './constants';

export function setLoading(bool) {
  return (dispatch, getState) => {
    if (bool === undefined || bool === null)
      throw new Error('Must specify whether app is loading or not.');

    return Promise.resolve()
    .then(() => {
      dispatch({
        type: SET_LOADING,
        payload: bool
      });
    });
  }
}

export function setPercent(percent) {
  return (dispatch, getState) => {
    return Promise.resolve()
    .then(() => {
      dispatch({
        type: SET_PERCENT,
        payload: percent
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/loading/actions.js